import { FullWidthBar } from 'components/core-v2'
import { SearchField } from 'components/core-v2/molecules/fields/search-field'
import { FormProvider, useForm } from 'react-hook-form'
import { useLocation } from 'react-router-dom'

import { TradesFilters } from '../../components/trades-filters'
import { TradesFoundBar } from '../../components/trades-found-bar'
import { TradesTable } from '../../components/trades-table'
import { ReportingTemplate } from '../../templates/top-level-tab-template'
import classes from './index.module.scss'

export const ReportingTradesList = () => {
  const location = useLocation()
  const defaultValues = location?.state?.tradeFilterFormValues || {}

  const form = useForm({
    defaultValues
  })

  return (
    <ReportingTemplate withOverflow withPadding backgroundColor="white" tabValue="trades">
      <FormProvider {...form}>
        <FullWidthBar showBottomBorder shouldPadXAxis={false} size="large">
          <SearchField className={classes.searchField} debounceMs={400} id="trades-search" />
          <SearchField className={classes.searchField} debounceMs={400} id="portfolio-search" />
          <TradesFilters />
        </FullWidthBar>
        <TradesFoundBar />
        <TradesTable />
      </FormProvider>
    </ReportingTemplate>
  )
}
